
export const APP_SET = 'APP_SET';
export const APP_SELECT_LANGUAGE = "APP_SELECT_LANGUAGE"
export const APP_SET_NAV_ITEMS = 'APP_SET_NAV_ITEMS'
export const APP_SET_TOASTER_MSG = "APP_SET_TOASTER_MSG"

